// DevHub UI kit — shared input validation.
//
// Home of the app's ONE email-shape check. It was defined inside the DevSecOps hub's
// dsoShared.tsx, but that module also imports ~20 tool logo PNGs, so a caller outside
// the hub (the entity About card's Contact row) that imported it from there would drag
// those assets into the eagerly-loaded bundle. dsoShared re-exports it from here, so
// its own callers are unchanged.

// Pragmatic RFC-ish check. Quantifiers are bounded (RFC 5321 local/domain-label
// limits) so a pathological input can't force quadratic backtracking (Sonar dos hotspot).
const EMAIL_RE = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{1,63}$/;

/** True when `value` is email-shaped (leading/trailing whitespace is ignored). */
export const isValidEmail = (value: string): boolean => EMAIL_RE.test(value.trim());
